import {Routes} from "@angular/router";
import {WorkflowEndcustomerOneDowngradeCuComponent} from "./workflow-endcustomer-one-downgrade-cu.component";

export const workflowEndcustomerOneDowngradeCuRouting: Routes = [
    { path: 'downgrade-cu/:aid', component: WorkflowEndcustomerOneDowngradeCuComponent, children: [
            { path: 'info', component: WorkflowEndcustomerOneDowngradeCuComponent },
            { path: 'address', component: WorkflowEndcustomerOneDowngradeCuComponent },
            { path: 'payment', component: WorkflowEndcustomerOneDowngradeCuComponent },
            { path: 'checkout', component: WorkflowEndcustomerOneDowngradeCuComponent },
            { path: 'complete', component: WorkflowEndcustomerOneDowngradeCuComponent },
            { path: '', redirectTo: 'info', pathMatch: 'full' },
    ]},
]
